var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"z-table-col z-table-col--body",attrs:{"colspan":_vm.colspan}},[(_vm.isMobile() || _vm.isTablet())?_c('span',{staticClass:"z-table-col__title",domProps:{"innerHTML":_vm._s(_vm.data[_vm.index])}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"z-table-col__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }